export function isTokenExpired(): boolean {
  const expiresAt = localStorage.getItem('token_expires_at')
  if (!expiresAt) return true

  return new Date() > new Date(expiresAt)
}
